import { RgbColorType, RgbFormat, RgbFormatType, RgbObject } from '../../models';

const HEX_REGEX = /^#[0-9a-fA-F]{6}$/;

/* Function overloading */
export function convertHexToRgb(hex: string, rgbFormat: RgbFormat.Color): RgbColorType;
export function convertHexToRgb(hex: string, rgbFormat: RgbFormat.Object): RgbObject;
export function convertHexToRgb(hex: string): RgbColorType;

/* Function implementation */
export function convertHexToRgb(hex: string, rgbFormat: RgbFormatType = RgbFormat.Color): RgbObject | RgbColorType {
  if (!HEX_REGEX.test(hex)) {
    throw new Error('Invalid HEX string format');
  }

  const bigint = parseInt(hex.slice(1), 16);
  const red = (bigint >> 16) & 255;
  const green = (bigint >> 8) & 255;
  const blue = bigint & 255;

  switch (rgbFormat) {
    case RgbFormat.Color:
      return `rgb(${red}, ${green}, ${blue})`;
    case RgbFormat.Object:
      return { red, green, blue };
  }
}
